const CONFIG = {
  adminEmails: 'Admin E-Mails (kommasepariert)',
  order_number: 'Bestellnummer',
  request_number: 'Anfragennummer',
  order_prefix: 'Bestellprefix',
  request_prefix: 'Anfragenprefix',
};

export default CONFIG;
